import { crearClienteSupabase, type ClienteEG } from '@eg/compartido'
import { DEMO } from '../demo/modo'

// En la demostración la tienda usa un servidor simulado en el navegador. La rama de la demo se elimina al compilar
// la tienda real (DEMO es una constante de compilación), así que ese código no viaja a producción.
export const supabase: ClienteEG | null = DEMO
  ? (await import('../demo/servidorDemo')).crearClienteDemo()
  : crearClienteSupabase(import.meta.env.VITE_SUPABASE_URL, import.meta.env.VITE_SUPABASE_PUBLISHABLE_KEY)
